import { cx } from "@suse-o11y/class-variance";
import { HourMinutesSecondsMillis } from "@suse-o11y/date-time/format/clock-time-format";
import { formatAbsoluteTime } from "@suse-o11y/date-time/format/format-absolute-time";
import type { Time } from "@suse-o11y/date-time/time";
import React from "react";

export const DiffHeader = ({
	className,
	originalTimestamp,
	modifiedTimestamp,
}: {
	className?: string;
	originalTimestamp: Time | number;
	modifiedTimestamp: Time | number;
}) => (
	<div className={cx("join-rounded-sm flex flex-row bg-grey-200 pr-8", className)}>
		<h2 className="mb-0 w-1/2 p-3 font-normal text-xs">
			Previous -{" "}
			{formatAbsoluteTime(originalTimestamp, {
				clockTimeFormat: HourMinutesSecondsMillis,
			}).toString()}
		</h2>

		<h2 className="mb-0 w-1/2 border-grey-400 border-l-px p-3 font-bold text-xs">
			Change -{" "}
			{formatAbsoluteTime(modifiedTimestamp, {
				clockTimeFormat: HourMinutesSecondsMillis,
			}).toString()}
		</h2>
	</div>
);
